// extracted by mini-css-extract-plugin
export default {"pageWrap":"ab-z","fullWidth":"bb-z","heading":"cb-z","fullBleed":"db-z","hidden":"eb-z"};